import client from "../auth/client";



export const fetchFileFromDocumentStore = async (feature: string, current_path: string) => {
    const res = await client.post("/common/demo_doc_store_fetch/", {
      feature: feature,
      current_path:current_path,
   
    });
  
    return res.data;
  };

  export const uploadFileToGCS = async (feature: string, token: string,  files: File[], id_template_mapping: Record<string, any>) => {
    const res = await client.post("/common/demo_doc_store_select_docs/", {
      "feature": feature,
      "token": token,
      "id_template_mapping": id_template_mapping.id === "" ? "123e4567-e89b-12d3-a456-426614174000" : id_template_mapping.id,

    
      "files": files,
      
    });
  
    return res.data;
  };